import { Link } from "react-router-dom";

export function toLocalDateTime({ value }) {
  let d = new Date(value).toLocaleString();
  return d === "Invalid Date" ? "N/A" : d;
}

export function toLocalDate({ value }) {
  let d = new Date(value).toLocaleDateString();
  return d === "Invalid Date" ? "N/A" : d;
}

export function renderNavigator(params) {
  return (
    <Link
      to={`${params?.data?.id}`}
      className={ "ag-cell-view-button"}
    >
      {"View"}
    </Link>
  );
}
export function renderNavigatorTranID(params) {
  return (
    <Link
      to={`${params?.data?.tranid}`}
      className={ "ag-cell-view-button"}
    >
      {"View"}
    </Link>
  );
}
export function renderTAbNavigator(params) {
  return (
    <Link
      to={""}
      className={params.value ? "ag-cell-view-button" : ""}
    >
      {params.value}
    </Link>
  );
}
export function renderViewNavigator(params) {
  // console.log(params,"params")
  return (
    <Link
    to={""}
      className={`${params.value ? "ag-cell-view-button" : ""}`}
    >
      {"View"}
    </Link>
  );
}
export function renderRevenueNavigator(params) {
  console.log(params,"params")
  return (
    <Link
      to={`/transaction-type/${(params?.data?.linkingname==="bill-payment"?"bill-payment-list":params?.data?.linkingname==="bill-credit"?"bill-credit-list":params?.data?.linkingname==="bill"?"vendor-bill-list":params?.data?.linkingname)}/${params?.data?.linkingid}`}
      className={params.value ? "ag-cell-view-button" : ""}
    >
      {params.value}
    </Link>
  );
}
export function renderAppliedNavigator(params) {
  console.log(params,"params")
  // (params?.data?.type === "Invoice")?params?.data?.type = "invoice" : "";
  // const linkingname = toLowerCase(params?.data?.type);
  return (
    <Link
      to={`/transaction-type/${params?.data?.type.toLowerCase()}/${params?.data?.linked_id}`}
      className={params.value ? "ag-cell-view-button" : ""}
    >
      {params.value}
    </Link>
  );
}
export function renderBillNavigator(params) {
  // console.log(params,"params")
  return (
    <Link
      to={`/transaction-type/vendor-bill-list/${params?.data?.transid}`}
      className={params.value ? "ag-cell-view-button" : ""}
    >
      {params.value}
    </Link>
  );
}
export function renderRevenueNavigatorWithID(params) {
  // console.log(params,"params")
  return (
    <Link
      to={`/transaction-type/${params?.data?.linkingname}/${params?.data?.id}`}
      className={params.value ? "ag-cell-view-button" : ""}
    >
      {params.value}
    </Link>
  );
}
export function renderSearchNavigator(params) {
  // console.log(params,"params")
  return (
    <a
      href={`/transaction-type/${params?.data?.linkingname}/${params?.data?.id}`}
      className={params.value ? "ag-cell-view-button" : ""}
    >
      {params.value}
    </a>
  );
}
export function renderNavigatorView(params) {
  return (
    <Link
      to={`${params?.data?.id}`}
      //className={`${params.value ? "ag-cell-view-button" : ""}`}
      className="ag-cell-view-button"
    >
      {"VIEW"}
    </Link>
  );
}
export function renderNavigatorByName(params) {
  return (
    <Link
      to={`${params?.data?.table_name}/${encodeURIComponent(params?.data?.report_name)}`}
      className={params.value ? "ag-cell-view-button" : ""}
    >
      {params.value}
    </Link>
  );
}
export function renderNavigatorBySavedReport(params) {
  return (
    <Link
      to={`${params?.data?.table_name}/${encodeURIComponent(params?.data?.report_name)}`}
      className={params.value ? "ag-cell-view-button" : ""}
    >
      {params.value}
    </Link>
  );
}
export function ListrenderNavigatorByName(params) {
  return (
    <Link
      to={`${params?.data?.table_name}`}
      className={params.value ? "ag-cell-view-button" : ""}
    >
      {params.value}
    </Link>
  );
}
export function renderNavigatorByTableName(params) {
  return (
    <Link
      to={`${params?.data?.table_name}`}
      className={params.value ? "ag-cell-view-button" : ""}
    >
      {params.value}
    </Link>
  );
}
export function renderOrderIdNavigator(params) {
  return (
    <Link
      className="link-color"
      target="_blank"
      to={
        "/transaction-type/" +
        `${params?.data?.linkpage}` +
        "/" +
        `${params?.data?.id}`
      }
    >
      {params?.data?.date}
    </Link>
  );
}
export function renderOrderIdNavigatorNumber(params) {
  return (
    <Link
      className="link-color"
      target="_blank"
      to={
        "/transaction-type/" +
        `${params?.data?.linkpage}` +
        "/" +
        `${params?.data?.id}`
      }
    >
      {params?.data?.number}
    </Link>
  );
}

export function renderProjectIdNavigator(params) {
  return (
    <Link
      className="link-color"
      target="_blank"
      to={"/lists/lists_projects/" + `${params?.data?.project_internal_id}`}
    >
      {params?.data?.project}
    </Link>
  );
}

export const formatCurrency = (params) => {
  return params.value
    ? `${new Intl.NumberFormat("en-US").format(params.value)}`
    : "";
  //return params.value ? `$${new Intl.NumberFormat('en-US').format(params.value)}` : "N/A";
};

export const formatFileSize = (params) => {
  const units = ["B", "KB", "MB", "GB", "TB"];
  let size = parseFloat(params.value); // Convert to a number using parseFloat
  let unitIndex = 0;

  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024;
    unitIndex++;
  }

  const decimalSize = size.toFixed(1);
  const unit = units[unitIndex];

  return `${decimalSize} ${unit}`;
};
export function getTransactionNotAvailable() {
  return {
    rows: [],
    total: "0",
    error: false,
  };
}

